export enum EmailImagesSize {
  Width = 240,
  Height = 200,
}
